import {
    BufferGeometry,
    BufferAttribute,
	Float32BufferAttribute,
	LineBasicMaterial,
	LineSegments,
	Raycaster,
	Object3D,
	Vector3,
    Box3,
} from 'three';

class measureHelper extends Object3D {

    private measure: LineSegments;
    private rayCaster: Raycaster;

    public point: Vector3;
    public distance: number;

    public direction: Vector3;

	constructor( public object: Object3D, private targets: Object3D[], private index: number) {

		super();

		this.object.updateMatrixWorld();

		this.matrix = object.matrixWorld;

		const geometry = new BufferGeometry();

		const positions = [
			0, 0, 0, 	0, -1, 0,
		];

		geometry.setAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
        geometry.computeBoundingSphere();

		const material = new LineBasicMaterial( { color: 0xff0000, fog: false, toneMapped: false } );

		this.measure = new LineSegments( geometry, material );
		this.add( this.measure );

        this.rayCaster = new Raycaster();

        this.distance = Infinity;
        this.point = new Vector3(-Infinity, -Infinity, -Infinity);
		this.update();
	}

	dispose() {

		this.measure.geometry.dispose();

        const materials = Array.isArray(this.measure.material) ? this.measure.material : [this.measure.material];

        materials.forEach(material => material.dispose());
	}
    
    // index = 0: 上, 1: 下, 2: 右, 3: 左
    private infos = [ {direction: () => new Vector3(0, 1, 0), rayPosition: (size) => new Vector3(0, size.y / 2, 0)}
                    ,{direction: () => new Vector3(0, -1, 0), rayPosition: (size) => new Vector3(0, - size.y / 2, 0)}
                    ,{direction: () => this.object.userData.obb.rightDirection(), rayPosition: (size) => this.object.userData.obb.rightPosition()}
                    ,{direction: () => this.object.userData.obb.leftDirection(), rayPosition: (size) => this.object.userData.obb.leftPosition()} ]

    // 法線の向きを取得(ワールドでの形状の向き)
    private normal () {
        const normal = this.object.getWorldDirection(new Vector3()).clone().normalize();
        if (normal.clone().cross(new Vector3(0,0,1)).length() < 0.1 && 0.9 <= Math.abs(normal.clone().dot(new Vector3(0,0,1))) && Math.abs (normal.clone().dot(new Vector3(0,0,1))) <= 1.1 ) return 0;      // Z
        if (normal.clone().cross(new Vector3(-1,0,0)).length() < 0.1 && 0.9 <= Math.abs ( normal.clone().dot(new Vector3(-1,0,0))) && Math.abs (normal.clone().dot(new Vector3(-1,0,0))) <= 1.1 ) return 1;   // -X
        if (normal.clone().cross(new Vector3(0,0,-1)).length() < 0.1 && 0.9 <= Math.abs (normal.clone().dot(new Vector3(0,0,-1))) && Math.abs (normal.clone().dot(new Vector3(0,0,-1))) <= 1.1 ) return 2;   // -Z
        if (normal.clone().cross(new Vector3(1,0,0)).length() < 0.1 && 0.9 <= Math.abs (normal.clone().dot(new Vector3(1,0,0))) && Math.abs (normal.clone().dot(new Vector3(1,0,0))) <= 1.1 ) return 3;     // X
    }

    setObj(object: THREE.Object3D) {
        this.object = object;
		this.matrix = object.matrixWorld;
    }

	update() {
		this.object.updateMatrixWorld();

        const bbox = new Box3().setFromObject(this.object);
        const center = bbox.getCenter(new Vector3());
        const size = bbox.getSize(new Vector3);

        const info = this.infos[this.index];
        const rayPosition = center.add(info.rayPosition(size));

        this.direction = info.direction();
        this.rayCaster.set(rayPosition, info.direction());
        const hitObj = this.rayCaster.intersectObjects(this.targets, true);

        if (hitObj.length <= 0) {
            this.measure.visible = false;
            this.point = new Vector3(-Infinity, -Infinity, -Infinity);
            this.distance = -Infinity;
            return;
        }
        this.measure.visible = true;

        this.point = rayPosition.clone();
        this.distance = hitObj[0].distance;

        const intersect = this.direction.clone().multiplyScalar(hitObj[0].distance);

        const m = this.matrixWorld.clone().invert();
        rayPosition.applyMatrix4(m);

        const vertexes = <BufferAttribute>this.measure.geometry.attributes.position;
        vertexes.setXYZ(0, rayPosition.x, rayPosition.y, rayPosition.z);
        vertexes.setXYZ(1, rayPosition.x + intersect.x, rayPosition.y + intersect.y, rayPosition.z + intersect.z);

        vertexes.needsUpdate = true;
        this.measure.geometry.computeBoundingSphere();
	}

}

export { measureHelper };
